<script>
  import { searchParamsStore } from "../stores.js";
  let threshold = $searchParamsStore.percentageCorrectThreshold;

  function handleChange() {
    searchParamsStore.update(store => {
      store.percentageCorrectThreshold = threshold;
      return store;
    });
  }

  function changeThresold(val) {
    threshold = val;
    handleChange();
  }

  $: checkIfActive = val => {
    if (val === threshold) return "active";
  };
</script>

<style>
  .button-group {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0.2rem;
  }

  .button-group button {
    cursor: pointer;
    padding: 0.3rem;
    font-size: 12px;
    border-radius: 6px;
    box-shadow: var(--button-tiny-box-shadow);
    border: 1px solid #ddd;
    background: none;
    transition: all 0.3s, color 0;
  }

  .button-group .active {
    background: var(--blue);
    border: 1px solid var(--blue);
    color: white;
  }

  .button-group button:hover {
    transform: translate(0, -1px);
    box-shadow: 0px 2px 3px rgba(112, 40, 45, 0.2);
  }

  .slider {
    margin: 0.5rem 0 1rem;
  }
</style>

<div>
  <div>
    Threshold:
    <strong>{threshold}%</strong>
  </div>
  <input
    class="slider"
    on:change={handleChange}
    type="range"
    min="0"
    max="100"
    bind:value={threshold}
    step="1" />
  <section class="button-group">
    <button class={checkIfActive(100)} on:click={() => changeThresold(100)}>
      100%
    </button>
    <button class={checkIfActive(95)} on:click={() => changeThresold(95)}>
      95%
    </button>
    <button class={checkIfActive(90)} on:click={() => changeThresold(90)}>
      90%
    </button>
    <button class={checkIfActive(85)} on:click={() => changeThresold(85)}>
      85%
    </button>
    <button class={checkIfActive(80)} on:click={() => changeThresold(80)}>
      80%
    </button>
    <button class={checkIfActive(75)} on:click={() => changeThresold(75)}>
      75%
    </button>
    <button class={checkIfActive(70)} on:click={() => changeThresold(70)}>
      70%
    </button>
    <button class={checkIfActive(65)} on:click={() => changeThresold(65)}>
      65%
    </button>
    <button class={checkIfActive(60)} on:click={() => changeThresold(60)}>
      60%
    </button>
    <button class={checkIfActive(50)} on:click={() => changeThresold(50)}>
      50%
    </button>
  </section>
</div>
